export const hideInPrintMixin = () => {
  return `
    @media print {
      display: none;
    }
  `;
};
